import RoutePath from 'components/RoutePath'
import LeftArrow from 'components/icons/LeftArrow'
import {
  LeftSection,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  TopHeader,
  TopEndFlex
} from 'modules/Drives/ViewDrive/Style/style'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import { PaddedDiv, SectionWrapper } from 'modules/Roles/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { Div } from '../../Drives/ViewDrive/Style/style'
import ViewRoleChart from '../ViewRole/ViewRoleChart/index'
import Button from 'components/Button'


const ViewRoleCharted = ({
  roleViewCardData,
  roleViewCardDataATS,
  roleViewChartData,
  getRoleViewChart,
  getRoleViewCard,
  getRoleViewCardATS,
  singleRoleData,
}) => {
  const navigate = useNavigate()
  const [jobId, setJobId] = useState([])
  const params = useParams()

  useEffect(() => {
    setJobId(params.jobId)
  }, [params.jobId])

  useEffect(() => {
    getRoleViewChart({ roleId: params.jobId })
    getRoleViewCard({ roleId: params.jobId })
    getRoleViewCardATS({ roleId: params.jobId })
  }, [params]);
  const handleNavigate = ()=>{
    navigate(`/drives/${singleRoleData.driveRoleMap[0].id}/role/${params.jobId}`)
  }

  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <Div>
              <Link to={`/roles`}>
                <LeftArrow />
              </Link>
            </Div>
            <SectionName column>
              <RoutePath from="Role " on={'View Role'} path={`/roles`} />
              <RoleNameFlex alignCenter>
                  <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
                <RoleStatus status={singleRoleData?.status} />
              </RoleNameFlex>
            </SectionName>
          </LeftSection>
           <TopEndFlex>
                <Button.Secondary
                          height={'38px'}
                          text="View Evaluation Process"
                          onClick={handleNavigate}
                          disabled={singleRoleData?._count?.jobRoleInstituteMap == 0}
                        />
           </TopEndFlex>
        </TopHeader>
      </PaddedDiv>
      <ViewRoleChart
        roleViewCardData={roleViewCardData}
        roleViewCardDataATS={roleViewCardDataATS}
        roleViewChartData={roleViewChartData}
        jobId={jobId}
        singleRoleData={singleRoleData}
      />
    </SectionWrapper>
  )
}

export default ViewRoleCharted
